import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../../pages/WorldMapPage.css';

// Fades the destination in when the player arrives through the gateway transition.
export default function GatewayArrival() {
  const location = useLocation();
  const [done, setDone] = useState(false);

  if (done || !location.state?.fromGateway) return null;
  return <div className="gw-arrival" aria-hidden="true" onAnimationEnd={() => setDone(true)} />;
}
